import '../../css/blocks/contentcards.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const contentcardsBlocks = document.querySelectorAll('.contentcards');
  
  if (contentcardsBlocks.length) {
    // Initialize block-specific functionality here
  }
});
